import { GET_BLAKLIST_APP_NOTIFICATION, GET_LIST_APP_NOTIFICATION, UPDATE_STATE_APP_NOTIFICATION } from 'shared/constants/ActionTypes';

const tmpApp = [
    {
        "id": "Produk Hukum",
        "value": "Produk Hukum"
    },
    {
        "id": "Dokumen Lain",
        "value": "Dokumen Lain"
    },
    {
        "id": "PKRL",
        "value": "PKRL"
    },
    {
        "id": "SK",
        "value": "Dokumen SK"
    },
    {
        "id": "korespondensi",
        "value": "Korespondensi"
    },
    {
        "id": "cuti",
        "value": "Cuti"
    }
]

const INIT_STATE = {
    app: {
        results: [],
    },
    blacklist: {
        results: [],
    },
};

const pengaturanNotifikasiReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BLAKLIST_APP_NOTIFICATION: {
            return {
                ...state,
                blacklist: action.payload,
            }
        }
        case GET_LIST_APP_NOTIFICATION: {
            const blacklistApp = state.blacklist.results
            const results = action.payload?.results && action.payload?.results.length > 0 ? [...action.payload.results] : [...tmpApp]
            const tmpData = {
                ...action.payload,
                results: transformDataApp(results, blacklistApp)
            }

            return {
                ...state,
                app: tmpData
            }
        }
        case UPDATE_STATE_APP_NOTIFICATION: {
            const blacklistApp = state.blacklist.results
            const results = state?.app?.results.lentgh > 0 ? [...state.app.results] : [...tmpApp]
            const tmpData = {
                ...action.payload,
                results: transformDataApp(results, blacklistApp)
            }

            return {
                ...state,
                app: tmpData
            }
        }
        default:
            return state;
    }
};

function addLevels(items, level = 0) {
    return items.map(item => ({
        ...item,
        level,
        children: item.children ? addLevels(item.children, level + 1) : []
    }))
}

function updateParentEnabled(items) {
    return items.map(item => {
        if (item.children && item.children.length > 0) {
            const updatedChildren = updateParentEnabled(item.children);

            const allChildrenOn = updatedChildren.every(
                c => c.emailEnabled === true && c.pushEnabled === true
            );

            return {
                ...item,
                enabled: allChildrenOn,
                children: updatedChildren
            };
        }
        return item;
    });
}

const transformDataApp = (list, blacklist) => {
    let apps = []
    let otherItems = []
    let specialApps = ["korespondensi", "cuti"]

    const pushMap = new Map()
    const emailMap = new Map()

    if (blacklist.length > 0) {
        blacklist.forEach(item => {
            if (item.notification_type === "email") {
                emailMap.set(item.service_name, item.id)
            } else if (item.notification_type === "push") {
                pushMap.set(item.service_name, item.id)
            }
        })
    }

    for (let i = 0; i < list.length; i++) {
        const appId = list[i].id;

        const item = {
            ...list[i],
            children: list[i].children || [],
            emailId: emailMap.get(appId) || "",
            pushId: pushMap.get(appId) || "",
            emailEnabled: !emailMap.has(appId),
            pushEnabled: !pushMap.has(appId)
        };

        if (specialApps.includes(appId)) {
            apps.push(item)
        } else {
            otherItems.push(item)
        }
    }
    apps.sort((a, b) => specialApps.indexOf(a.id) - specialApps.indexOf(b.id))

    apps.push({
        id: "digitalSign",
        canCheckAll: false,
        value: "Digital Sign",
        enabled: false,
        type: 'header',
        children: otherItems
    })

    apps = addLevels(apps)
    apps = updateParentEnabled(apps)

    return apps
}

export default pengaturanNotifikasiReducer;
